import * as React from 'react'
// components
import Row from './components/Row'
import { Button, BUTTON_LAYOUTS, Table } from 'components/UI'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
import { ObjectSecurityContext } from 'containers/Security/components/ObjectSecurity/layers/API'
// constants
import { Modals } from 'constants/modals'
// view components
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
import ObjectSecurityModal from 'components/Modals/ObjectSecurityModal'
// views
import { Title, TitleWrapper } from 'themes/views/security'

const headers = [
  { id: 'name', sortable: false, left: true, label: 'NAME' },
  { id: 'object', sortable: false, left: true, label: 'OBJECT' },
  { id: 'active', sortable: false, left: true, label: 'ACTIVE' },
  { id: 'profiles', sortable: false, left: true, label: 'PROFILES' },
  { id: 'description', sortable: false, left: true, label: 'DESCRIPTION' }
]

const ObjectSecurity: React.FC = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, refetch, totalCount, isRefetching } = React.useContext(ObjectSecurityContext)

  const { showModal } = useShowModal({ modalType: Modals.OBJECT_SECURITY_MODAL })

  return (
    <>
      <TitleWrapper>
        <Title>
          Object security allows profile to be associated with objects which are referenced and used to govern access to
          functions specific to individual records
        </Title>
        <Button onClick={() => showModal()} type='button' layout={BUTTON_LAYOUTS.PURPLE}>
          CREATE NEW
        </Button>
      </TitleWrapper>
      <Table
        data={data}
        page={page}
        headers={headers}
        perPage={perPage}
        refetch={refetch}
        totalCount={totalCount}
        isLoading={isRefetching}
        onPageChange={handleSetPage}
        onPerPageChange={handleSetPerPage}>
        {({ data }) => data.map((item) => <Row key={item.id} data={item} />)}
      </Table>

      <ObjectSecurityModal />
      <ConfirmDeleteModal header='Delete Object Security'>
        Are you sure you want to delete this object security?
      </ConfirmDeleteModal>
    </>
  )
}

export default ObjectSecurity
